import { render, staticRenderFns } from "./color.vue?vue&type=template&id=1a0a975e&"
import script from "./color.vue?vue&type=script&lang=js&"
export * from "./color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a0a975e')) {
      api.createRecord('1a0a975e', component.options)
    } else {
      api.reload('1a0a975e', component.options)
    }
    module.hot.accept("./color.vue?vue&type=template&id=1a0a975e&", function () {
      api.rerender('1a0a975e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/field-template/color.vue"
export default component.exports